export default "__VITE_ASSET__Lf6CMijk__"